import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import toast from 'react-hot-toast';

import { useAuth } from '../../../global/contexts/auth/auth';

// Shared "run a chain step" action for an OPU session, used by the clickable
// timeline (both in the list and the search panel). Forward jumps are blocked
// upstream (a step is only actionable when index ≤ reached+1); this just routes.
//   opu     → session landing
//   clivage → clivage form in a NEW TAB (clivages:write)
//   te / dx → next domains (forms pending)
export function useSessionActions() {
    const navigate = useNavigate();
    const { can } = useAuth();

    return useCallback((session, stepKey) => {
        if (!session?.id) return;
        switch (stepKey) {
            case 'opu':
                navigate(`/admin/opu/${session.id}`);
                break;
            case 'clivage': {
                if (!can('clivages', 'write')) { toast.error('No tenés permiso para registrar clivage'); return; }
                // if the session already has clivages → edit; else create.
                const hasClivages = (session.counts?.clivages_count || 0) > 0 || (session.resolution?.rollup?.clivages_count || 0) > 0;
                const url = hasClivages ? `/opu/clivage/edit?session=${session.id}` : `/opu/clivage?session=${session.id}`;
                window.open(url, '_blank', 'noopener');
                break;
            }
            case 'te': {
                if (!can('transfers', 'write')) { toast.error('No tenés permiso para registrar transferencias'); return; }
                window.open(`/opu/transfer?session=${session.id}`, '_blank', 'noopener');
                break;
            }
            case 'dx': {
                if (!can('pregnancies', 'read')) { toast.error('No tenés permiso para diagnósticos'); return; }
                // El Dx se ancla a la OPU (decisión del dueño): lista las TE de esta
                // OPU, filtrable por finca de la sesión TE.
                navigate(`/admin/dx?opu=${session.id}`);
                break;
            }
            default:
                break;
        }
    }, [navigate, can]);
}
